import React from 'react';
import { useIntl } from '../../util/reactIntl';
import { ExternalLink, LinkedLogo, NamedLink } from '../../components';
import css from './FooterContainer.module.css';
import Icons from '../../components/Icons/Icons';

function FooterContainer(props) {
  const intl = useIntl();

  return (
    <div className={css.footer}>
      <div className={css.fixedWidthContainer}>
        <div className={css.footerTop}>
          <div className={css.logo}>
            <LinkedLogo className={css.logoLink} layout="desktop" />
          </div>
          <div className={css.aboutCompany}>
            <p>{intl.formatMessage({ id: 'FooterContainer.aboutCompany' })}</p>
          </div>
          <div className={css.linksBlock}>
            <NamedLink className={css.link} name="LandingPage">
              {intl.formatMessage({ id: 'FooterContainer.home' })}
            </NamedLink>
            <NamedLink
              className={css.link}
              name="SearchPage"
              to={{
                search: 'pub_listingType=services',
              }}
            >
              {intl.formatMessage({ id: 'FooterContainer.services' })}
            </NamedLink>
            <NamedLink className={css.link} name="TermsOfServicePage">
              {intl.formatMessage({ id: 'FooterContainer.terms' })}
            </NamedLink>
            <NamedLink className={css.link} name="AboutPage">
              {intl.formatMessage({ id: 'FooterContainer.about' })}
            </NamedLink>
            <NamedLink className={css.link} name="PrivacyPolicyPage">
              {intl.formatMessage({ id: 'FooterContainer.privacy' })}
            </NamedLink>
          </div>
        </div>
        <div className={css.footerBottom}>
          <div className={css.footerBottomLeft}>
            <p>{intl.formatMessage({ id: 'FooterContainer.copyRight' })}</p>
          </div>
          <div className={css.footerBottomRight}>
            <div className={css.socialLinks}>
              <div
                className={css.insta}
                onClick={() =>
                  typeof window !== 'undefined' &&
                  window.open('https://www.instagram.com/sbmarketco', '_blank')
                }
              >
                <Icons name="instagram" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FooterContainer;
